import * as React from 'react'

const SvgIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 50}
    height={props.height || 50}
    fill='none'
    viewBox='0 0 50 50'
    {...props}
  >
    <rect width='50' height='50' fill='#4050FB' rx='10'></rect>
    <mask
      id='mask0_13_93'
      width='5'
      height='5'
      x='13'
      y='16'
      maskUnits='userSpaceOnUse'
      style={{ maskType: 'luminance' }}
    >
      <path
        fill='#fff'
        d='M17.4 18.065a2.06 2.06 0 0 1-2.056 2.066 2.06 2.06 0 0 1-2.055-2.066c0-1.14.92-2.065 2.055-2.065 1.135-.012 2.056.913 2.056 2.065'
      ></path>
    </mask>
    <g mask='url(#mask0_13_93)'>
      <path fill='#F7F8FF' d='M13.289 16h4.11v4.13h-4.11z'></path>
    </g>
    <mask
      id='mask1_13_93'
      width='5'
      height='5'
      x='13'
      y='16'
      maskUnits='userSpaceOnUse'
      style={{ maskType: 'luminance' }}
    >
      <path
        fill='#fff'
        d='M17.477 18.065A2.066 2.066 0 1 1 15.41 16a2.05 2.05 0 0 1 2.067 2.065'
      ></path>
    </mask>
    <g mask='url(#mask1_13_93)'>
      <path fill='#F7F8FF' d='M13.344 16h4.133v4.13h-4.133z'></path>
    </g>
    <mask
      id='mask2_13_93'
      width='9'
      height='17'
      x='3'
      y='17'
      maskUnits='userSpaceOnUse'
      style={{ maskType: 'luminance' }}
    >
      <path
        fill='#fff'
        d='M8.25 17.8v3.255h3.568v3.062H8.262v5.08c0 1.128.516 1.572 1.682 1.572h1.886v2.93H9.703c-3.351 0-4.865-1.5-4.865-4.335v-5.247H3v-3.062c1.01 0 1.826-.817 1.826-1.825V17.8z'
      ></path>
    </mask>
    <g mask='url(#mask2_13_93)'>
      <path fill='#F7F8FF' d='M3 17.8h8.83v15.9H3z'></path>
    </g>
    <mask
      id='mask3_13_93'
      width='5'
      height='13'
      x='13'
      y='21'
      maskUnits='userSpaceOnUse'
      style={{ maskType: 'luminance' }}
    >
      <path fill='#fff' d='M17.115 21.056V33.7h-3.424V21.056z'></path>
    </mask>
    <g mask='url(#mask3_13_93)'>
      <path fill='#F7F8FF' d='M13.691 21.056h3.424V33.7h-3.424z'></path>
    </g>
    <mask
      id='mask4_13_93'
      width='15'
      height='18'
      x='18'
      y='16'
      maskUnits='userSpaceOnUse'
      style={{ maskType: 'luminance' }}
    >
      <path
        fill='#fff'
        d='M32.18 16.816v16.895h-3.423v-.936c-.89.696-2.27 1.104-3.7 1.104a6.405 6.405 0 0 1-6.392-6.436c0-3.65 2.932-6.508 6.392-6.508 1.43 0 2.81.444 3.7 1.129v-5.248zm-6.823 7.23c-1.874 0-3.328 1.524-3.328 3.397 0 1.897 1.454 3.398 3.328 3.398 1.97 0 3.448-1.5 3.448-3.398 0-1.873-1.526-3.398-3.448-3.398'
      ></path>
    </mask>
    <g mask='url(#mask4_13_93)'>
      <path fill='#F7F8FF' d='M18.665 16.816h13.516V33.88H18.665z'></path>
    </g>
    <mask
      id='mask5_13_93'
      width='14'
      height='14'
      x='33'
      y='20'
      maskUnits='userSpaceOnUse'
      style={{ maskType: 'luminance' }}
    >
      <path
        fill='#fff'
        d='M40.013 20.815c4 0 6.415 2.762 6.415 6.437q0 .127-.004.262l-.002.09c-.013.402-.042.796-.042.86h-9.67c.372 1.597 1.573 2.642 3.351 2.642 1.526 0 2.643-.66 3.352-1.681l2.57 1.573C44.759 32.848 42.8 34 39.99 34c-4.049 0-6.655-2.834-6.655-6.58 0-3.65 2.714-6.605 6.679-6.605m-.024 2.81c-1.598 0-2.715.865-3.16 2.294h6.14c-.373-1.525-1.599-2.294-2.98-2.294'
      ></path>
    </mask>
    <g mask='url(#mask5_13_93)'>
      <path fill='#F7F8FF' d='M33.334 20.815h13.094V34H33.334z'></path>
    </g>
  </svg>
)

export default SvgIcon
